type GenerateWrapperIdProps = {
  src: string;
  id: string;
};

type LoggerProps = [
  string,
  {
    src: string;
    id?: string;
    old_src?: string;
  },
];

const status = (res: Response) =>
  res.status >= 200 && res.status < 300
    ? Promise.resolve(res)
    : Promise.reject(new Error(res.statusText));

const text = (res: Response) => res.text();

export async function fetchFragment(src: string) {
  try {
    return await fetch(src).then(status).then(text);
  } catch (error) {
    return null;
  }
}

export const isClient = () =>
  Boolean(typeof window !== "undefined" && window.document);

export const selectInjectedHtml = (wrapperId: string, esiId: string) => {
  if (wrapperId) {
    const wrapperEl = document.getElementById(wrapperId);
    if (wrapperEl) {
      const esiEl = wrapperEl.querySelector(`#${esiId}`);
      return esiEl ? null : wrapperEl.innerHTML;
    }
  }
  return null;
};

export const generateWrapperId = ({ id, src }: GenerateWrapperIdProps) => {
  // Use the src prop to generate an id attribute for the wrapping element
  const regex = /\/?([\w-/]*)/;
  let wrapperId = "";
  if (src) {
    const assemblySource = src.match(regex) || [];
    wrapperId = `assembly-${assemblySource[1]}-${id}`
      .replace(/\//g, "-") // change / to -
      .replace(/-+/g, "-") // remove duplicate -
      .toLowerCase();
  }

  return wrapperId;
};

export const logger = (...args: LoggerProps) => {
  if (!isClient()) {
    return;
  }

  if (localStorage.getItem("ESIIncludeWithClientFetch-debug") === "true") {
    /* eslint-disable no-console */
    console.log(...args);
  }
};
